export default __webpack_public_path__ + "static/media/Phosphorus.be7707b3.jpeg";